import getResizedImageUrl from './getResizedImageUrl';

export default (src: string, large?: boolean) => {
  return getResizedImageUrl(src, large ? 80 : 48);
};
